const pid = parseInt($('#Project_Pid').val());

export default function () {
  let $attendeesTopic = $('#attendees.topic');
  if ($attendeesTopic.length) {
    loadAttendeesSection();
  }
}

const loadAttendeesSection = function () {
  let $attendeesContainer = $('#attendeesContainer');
  if ($attendeesContainer.length && !$attendeesContainer.children().length) {
    let attendeeDetails = {
      pid: pid, section: $('#sectionName').val(), mid: $('#Id').val() || -1, canAdd: $('#Finalized').val() == "False"
    };
    if (attendeeDetails.section) {
      $attendeesContainer.load('/Forms/ProjectReview/GetMeetingAttendees', attendeeDetails, function () {
          attachAttendeeEvents();
      });
    }
  } else {
    attachAttendeeEvents();
  }
};

const attachAttendeeEvents = function () {
  let $addAttendeeBtn = $('#AddAttendeeBtn');
  if ($addAttendeeBtn.length) {
    $addAttendeeBtn.click(addAttendee);
  }
  let $removeAttendeeBtns = $('[data-role="removeAttendee"]');
  if ($removeAttendeeBtns.length) {
    $removeAttendeeBtns.click(removeAttendee);
  }
};

const addAttendee = function (event) {
  event.preventDefault();

  let attendeeFull = $('#AttendeeText').val().substring(0, 6);
  let empNum = parseInt(attendeeFull);

  if (!isNaN(empNum)) {
    //success
    let attendeeDetails = {
      pid: pid, section: $('#sectionName').val(), empNum: empNum, mid: $('#Id').val() || -1
    };
    if (attendeeDetails.section) {
      $('#attendeesContainer').load('/Forms/ProjectReview/AddMeetingAttendee', attendeeDetails, function () {
        attachAttendeeEvents();
      });
    }
  } else {
    kendo._l.showErrorNotification('Please select full employee record from suggested Emp #/Names.');
  }
};

const removeAttendee = function (event) {
  event.preventDefault();
  let attendeeDetails = {
    pid: pid, section: $('#sectionName').val(), empNum: $(event.currentTarget).attr('data-empId'), mid: $('#Id').val() || -1
  };
  if (attendeeDetails.section) {
    $('#attendeesContainer').load('/Forms/ProjectReview/RemoveMeetingAttendee', attendeeDetails, function () {
      attachAttendeeEvents();
    });
  }
};